import { CLASSIFICACAO } from '@/lib/classificacao';
import { type TomCarimbo } from '@/ui/components/carimbo';
import { type TomBadge } from '@/ui/primitives/estilos';
import {
  type ClassificacaoNota,
  type Direcao,
  type GrupoContabil,
  type ModeloDocumento,
  type Severidade,
  type SituacaoDocumento,
  type StatusClassificacao,
} from '@fiscoai/contracts';

export { CLASSIFICACAO, OPCOES_CLASSIFICACAO } from '@/lib/classificacao';

export const SITUACAO: Record<SituacaoDocumento, { rotulo: string; tom: TomCarimbo }> = {
  AUTORIZADA: { rotulo: 'Autorizada', tom: 'sucesso' },
  CANCELADA: { rotulo: 'Cancelada', tom: 'perigo' },
  DENEGADA: { rotulo: 'Denegada', tom: 'alerta' },
  DESCONHECIDA: { rotulo: 'Sem protocolo', tom: 'neutro' },
};

export const MODELO: Record<ModeloDocumento, string> = {
  NFE_55: 'NF-e',
  NFCE_65: 'NFC-e',
  CTE_57: 'CT-e',
  CTE_OS_67: 'CT-e OS',
  NFSE: 'NFS-e',
};

export const DIRECAO: Record<Direcao, string> = { ENTRADA: 'Entrada', SAIDA: 'Saída' };

/** Campo tpNF do DANFE ("0 - Entrada / 1 - Saída"): o ponto de vista de quem EMITIU a nota. */
export const TIPO_DANFE: Record<'0' | '1', Direcao> = { '0': 'ENTRADA', '1': 'SAIDA' };

/** Spec 0011: as classes do item mais a nota mista (itens com classificações diferentes). */
export const CLASSIFICACAO_NOTA: Record<ClassificacaoNota, string> = {
  ...CLASSIFICACAO,
  MISTA: 'Mista',
};

/** Spec 0011: o `tpNF` como o DANFE escreve. */
export const TIPO_OPERACAO: Record<'0' | '1', string> = { '0': '0 - Entrada', '1': '1 - Saída' };

export const AJUDA_TIPO_OPERACAO =
  'O campo “0 - Entrada / 1 - Saída” da nota, do ponto de vista de quem a emitiu. A nota de um fornecedor é 1 - Saída e entra na empresa.';

export const AJUDA_DIRECAO =
  'Direção do ponto de vista da empresa. Pode ser o oposto do campo “0 - Entrada / 1 - Saída” do DANFE, que mostra a visão de quem emitiu a nota.';

export const ORIGEM = {
  UPLOAD_XML: 'Upload de XML',
  UPLOAD_ZIP: 'Upload de ZIP',
  CONECTOR: 'Conector',
  API: 'API',
  MIGRACAO: 'Migração',
  SEFAZ_DFE: 'Captura SEFAZ',
} as const;

export const FORMA_PAGAMENTO: Record<string, string> = {
  '01': 'Dinheiro',
  '02': 'Cheque',
  '03': 'Cartão de crédito',
  '04': 'Cartão de débito',
  '05': 'Crédito loja',
  '15': 'Boleto',
  '16': 'Depósito',
  '17': 'PIX',
  '90': 'Sem pagamento',
  '99': 'Outros',
};

export const EVENTO: Record<string, string> = {
  '110111': 'Cancelamento',
  '110110': 'Carta de correção',
  '210200': 'Confirmação da operação',
  '210210': 'Ciência da operação',
  '210220': 'Desconhecimento da operação',
  '210240': 'Operação não realizada',
};

export const GRUPO_CONTABIL: Record<GrupoContabil, string> = {
  ATIVO: 'Ativo',
  CUSTO: 'Custo',
  DESPESA: 'Despesa',
};

export const STATUS_CLASSIFICACAO: Record<StatusClassificacao, { rotulo: string; tom: TomBadge }> =
  {
    NAO_SE_APLICA: { rotulo: 'Não se aplica', tom: 'neutro' },
    PENDENTE: { rotulo: 'A classificar', tom: 'alerta' },
    PARCIAL: { rotulo: 'Parcial', tom: 'info' },
    COMPLETA: { rotulo: 'Classificada', tom: 'sucesso' },
  };

export const SEVERIDADE: Record<Severidade, { rotulo: string; tom: TomBadge }> = {
  ERRO: { rotulo: 'Erro', tom: 'perigo' },
  ALERTA: { rotulo: 'Alerta', tom: 'alerta' },
  INFORMACAO: { rotulo: 'Informação', tom: 'info' },
};
